import { useCurrentUser } from './queries';
import { isProjectOwner } from '../../utils/projectUtils';

/**
 * Hook to determine if the current user is the project owner
 * @param {object} project - The project object
 * @returns {boolean} True if current user is the project owner
 */
export function useIsProjectOwner(project) {
  const { data: currentUser } = useCurrentUser();
  
  return isProjectOwner(project, currentUser);
}